import React from 'react';
import EnquiryTemplate7 from './enquiry/EnquiryTemplate7';
import EnquiryTemplate8 from './enquiry/EnquiryTemplate8';
import EnquiryTemplate9 from './enquiry/EnquiryTemplate9';
import EnquiryTemplate10 from './enquiry/EnquiryTemplate10';
import EnquiryTemplate11 from './enquiry/EnquiryTemplate11';
import EnquiryTemplate12 from './enquiry/EnquiryTemplate12';
import EnquiryTemplate13 from './enquiry/EnquiryTemplate13';
import EnquiryTemplate14 from './enquiry/EnquiryTemplate14';
import EnquiryTemplate15 from './enquiry/EnquiryTemplate15';

// Template Registry - Maps template types to their components
const templateRegistry = {
  'template7': EnquiryTemplate7,  // Institute - Classic red theme
  'template8': EnquiryTemplate8,  // Institute - Modern card-based purple theme
  'template9': EnquiryTemplate9,  // Coaching Center - Compact pink/orange theme
  'template10': EnquiryTemplate10, // College - Professional blue theme
  'template11': EnquiryTemplate11, // University - Prestigious formal theme
  'template12': EnquiryTemplate12, // Modern App-Style - Fully responsive design
  'template13': EnquiryTemplate13, // Modern App-Style Clean - No banner, stats, or features
  'template14': EnquiryTemplate14, // IIG Mumbai - Simple Enquiry Form
  'template15': EnquiryTemplate15, // UTWILL - Student Admission Form
};

// Default template to use if templateType is not specified
const DEFAULT_TEMPLATE = 'template7';

// Component that dynamically renders the correct template based on configuration
function TemplateRegistry({ templateType, clientId }) {
  // Get the template component from the registry
  const TemplateComponent = templateRegistry[templateType] || templateRegistry[DEFAULT_TEMPLATE];

  // If template not found, show error
  if (!TemplateComponent) {
    return (
      <div style={{
        padding: '40px',
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif'
      }}>
        <h2 style={{ color: '#dc2626' }}>Template Error</h2>
        <p>Template type "{templateType}" not found in registry.</p>
        <p>Please check your client configuration.</p>
      </div>
    );
  }

  // Render the selected template component
  return <TemplateComponent clientId={clientId} />;
}

export default TemplateRegistry;
